import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import {
  getCSSColorBg,
  getCSSColorText,
  getCSSGridTemplateRows,
  getCSSSizeSmText,
} from '~/utilities/getCSS';
import NavItem from '~/components/Layout/Header/Desktop/NavItem';
import type { NumRowsType } from '~/types/NumRowsType';
import { NavContext } from '~/contexts/NavContext';
import type { NavItemType } from '~/types/NavItemType';

const dropdownClasses = cva(
  'hidden absolute py-2 px-2.5 grid grid-flow-col auto-rows-min overflow gap-y-2 gap-x-20',
  {
    variants: {
      color: getCSSColorText(),
      background: getCSSColorBg(),
      rows: getCSSGridTemplateRows(),
      sizeSm: getCSSSizeSmText(),
      level: {
        0: 'top-full',
        1: 'right-full -top-4',
      },
    },
  }
);

export default component$(
  ({ item, activeItem, level }: NavItemType): JSX.Element => {
    const { theme } = useContext(NavContext);
    const childrenNum = item.children?.length ? item.children.length : 1;
    const clampedLevel = level >= 1 ? 1 : 0;

    return (
      <ul
        class={dropdownClasses({
          background: theme.SubMenuBackgroundColor.value,
          rows: Math.min(childrenNum, 7) as unknown as NumRowsType,
          color: theme.LinkColorTypeNormal.value,
          sizeSm: theme.SubMenuLinksFontSize.value,
          level: clampedLevel,
        })}
      >
        {item.children?.map((each, index) => {
          return (
            <NavItem
              key={index}
              item={each}
              activeItem={activeItem}
              level={level + 1}
            />
          );
        })}
      </ul>
    );
  }
);
